import React from "react";
import Grid from "../Grid/grid";
import Title from "../title";
import Process from "../process";
import reactDevelopmentProcess from "./data/react-js-process-data";
import contentImage from "../../Assets/image/services-pages-images/react-js-images/react-js-content.webp"

function ReactJsProcess() {
  return (
    <section className="w-full min-h-screen h-full relative flex flex-col overflow-hidden p-2 lg:p-16">
      <Grid size={100} direction="top-left" />
      <div className="z-10 flex justify-start items-start mb-12 w-full">
        <Title title="our process" />
      </div>
      <Process
        data={reactDevelopmentProcess}
        img={contentImage}
        title="React Js Development"
        description="Crafting Fast, Scalable & Interactive Web Apps – React.js Solutions Designed for Seamless User Experiences."
      />
    </section>
  );
}

export default ReactJsProcess;
